import moment from 'moment';
import { useState } from 'react';
import ReactModal from 'react-modal';
import { URI } from '../../domain/constant';
import Spinner from '../layout/Spinner';
import TableDeleteBtn from './TableDeleteBtn';
import TableEditBtn from './TableEditBtn';
import TableViewBtn from './TableViewBtn';

import SingleView from '../../components/common/SingleView';

function DataTable({
  loading,
  data,
  page,
  keys,
  deleteBtnClicked,
  field,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  style,
  hideViewBtn,
  hideEditBtn,
  hideDeleteBtn,
}) {
  const LIMIT = new URLSearchParams(window.location.search).get('limit') || 10;

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  // State for delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Handler for delete button click
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  // Handler for confirming delete
  const handleConfirmDelete = () => {
    if (deleteId) {
      deleteBtnClicked(deleteId);
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };
  // Handler for canceling delete
  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  return (
    <div>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='table-responsive'>
            <table className='table align-middle   ' style={style}>
              <thead>
                <tr className='bg-transparent' role='row'>
                  <th style={{ width: '40px', textAlign: 'center' }}>#</th>
                  {keys &&
                    keys.map((item) => {
                      return <th> {item.name} </th>;
                    })}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  data &&
                  data.map((single, index) => {
                    return (
                      <tr key={`single-${index}`}>
                        <td
                          className='sorting_1'
                          style={{
                            width: '40px',
                            textAlign: 'center',
                            padding: '0.25rem',
                          }}
                        >
                          {index + 1 + (page - 1) * LIMIT}
                        </td>
                        {keys &&
                          keys.map((item) => {
                            if (item.image) {
                              return (
                                <td>
                                  <img
                                    src={`${URI}${single[item.value]}`}
                                    style={{
                                      height: '100px',
                                      width: 'auto',
                                      objectFit: 'contain',
                                    }}
                                  />{' '}
                                </td>
                              );
                            }
                            if (item.date) {
                              return (
                                <td>
                                  {!item.utc
                                    ? moment(single[item.value])
                                        .utc()
                                        .format('DD-MM-YYYY')
                                    : moment(single[item.value]).format(
                                        'DD-MM-YYYY'
                                      )}
                                </td>
                              );
                            }
                            if (item.related && item.field) {
                              return (
                                <td>
                                  {single[item.value] &&
                                    single[item.value][item.field]}
                                </td>
                              );
                            }

                            return (
                              <td>
                                {' '}
                                {item.preFilled ? item.preFilled : ''}{' '}
                                {single[item.value]}{' '}
                              </td>
                            );
                          })}
                        <td>
                          <button
                            className='btn btn-soft-light'
                            onClick={() => {
                              setModal(true);
                              setModalData(single);
                            }}
                          >
                            {' '}
                            <i className='fa fa-binoculars'></i>{' '}
                          </button>
                          {!hideViewBtn && (
                            <TableViewBtn id={single._id} item={field} />
                          )}
                          {!hideEditBtn && (
                            <TableEditBtn id={single._id} item={field} />
                          )}

                          {/* Updated: Pass handleDeleteClick instead of deleteBtnClicked */}
                          <TableDeleteBtn
                            id={single._id}
                            deleteBtnClicked={handleDeleteClick}
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={20} className='text-center'>
                      <Spinner />
                    </td>
                  </tr>
                )}
                {data && data.length === 0 && (
                  <tr>
                    <td colSpan={20}>No result found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ReactModal
        isOpen={modal}
        contentLabel='Modal'
        className='Modal'
        overlayClassName='Overlay'
        onRequestClose={() => {
          setModal(false);
        }}
      >
        <div className='quick-view'>
          <div className='qv-header'>
            <div className='title'> {PAGE_SINGLE_TITLE} </div>
            <div>
              <button
                onClick={() => {
                  setModal(false);
                }}
                className='btn btn-primary'
              >
                <i className='fa fa-times'></i>
              </button>
            </div>
          </div>
          {modalData && (
            <div className='qv-body'>
              <SingleView
                data={modalData}
                inputFields={inputFields}
                label={PAGE_SINGLE_TITLE}
                link={field}
                id={modalData._id}
                hideAllBtn={true}
                col={12}
              />
            </div>
          )}
        </div>
      </ReactModal>

      {/* Delete Confirmation Modal */}
      <ReactModal
        isOpen={showDeleteModal}
        contentLabel='Confirm Delete'
        className='Modal'
        overlayClassName='Overlay'
        onRequestClose={handleCancelDelete}
      >
        <div className='quick-view'>
          <div className='qv-header'>
            <div className='title'>
              <i className='fa fa-exclamation-triangle text-danger me-2'></i>
              Confirm Delete
            </div>
            <div>
              <button
                onClick={handleCancelDelete}
                className='btn btn-secondary'
              >
                <i className='fa fa-times'></i>
              </button>
            </div>
          </div>
          <div className='qv-body'>
            <p>
              Are you sure you want to delete this item? This action cannot be
              undone.
            </p>
          </div>
          <div className='qv-footer d-flex justify-content-end gap-2'>
            <button className='btn btn-secondary' onClick={handleCancelDelete}>
              Cancel
            </button>
            <button className='btn btn-danger' onClick={handleConfirmDelete}>
              Delete
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default DataTable;
